import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Requisito } from '../../../_models/requisito';
import { ListaItem } from '../../../_models/lista-item';
import { RequisitoGarantiaCantidadTipoVinculacion } from '../../../_models/requisito-garantia-cantidad-tipo-vinculacion';
import { RequisitoGarantiaCantidadTipoVinculacionService } from '../../../_services/requisito-garantia-cantidad-tipo-vinculacion.service';
import { ListaService } from '../../../_services/lista.service';
import { NavService } from '../../../_services/_nav.service';
import { RequisitoGarantiaCantidadService } from '../../../_services/requisito-garantia-cantidad.service';
import { RequisitoGarantiaCantidad } from '../../../_models/requisito-garantia-cantidad';

@Component( {
  selector: 'app-requisito-tipo-vinculacion',
  templateUrl: 'requisitos-tipo-vinculacion.component.html'
} )

export class RequisitosTipoVinculacionComponent implements OnInit {

  @Input() requisito: Requisito;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  lisTipoVinculacionTodos: ListaItem[] = [];
  lisTipoVinculacion: SelectItem[] = [];
  lisRequisitoCantidad: RequisitoGarantiaCantidad[] = [];
  lisRequisitoCantidadTodos: RequisitoGarantiaCantidad[] = [];
  lisRequisitoCantidadTipVin: RequisitoGarantiaCantidadTipoVinculacion[] = [];
  cargando = true;
  formulario: FormGroup;
  formularioDetalle: FormGroup;
  submitted = false;
  submittedD = false;
  columnas: any[] = [];
  editarRequisito = false;

  constructor(
    private navService: NavService,
    private fb: FormBuilder,
    private conService: ConfirmationService,
    private reqCantidadService: RequisitoGarantiaCantidadService,
    private reqCantTipoVinculacionService: RequisitoGarantiaCantidadTipoVinculacionService,
    private lisService: ListaService
  ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'tipoVinculacion', header: this.navService.buscarMensaje( 'REQUISITOTIPOVINCUACION.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'cantidad', header: this.navService.buscarMensaje( 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarInicial().then( x => {
      this.cargarListado();
      this.cargarFormulario();
      this.cargarVinculaciones();
      this.cargando = false;
    } );
  }

  private async cargarInicial() {
    const [ lisTiposVinculaciones, reqGarantCant, reqGarantCantTipVin ] = await forkJoin(
      this.lisService.getMasterDetails( 'ListasTiposVinculaciones' ),
      this.reqCantidadService.listadoPorIdRequisito( this.requisito.idRequisitoGarantia ),
      this.reqCantTipoVinculacionService.listadoPorIdRequisito( this.requisito.idRequisitoGarantia )
    ).toPromise();
    this.lisTipoVinculacionTodos = lisTiposVinculaciones;
    this.lisRequisitoCantidadTodos = reqGarantCant;
    this.lisRequisitoCantidadTipVin = reqGarantCantTipVin;
    this.lisRequisitoCantidadTodos.forEach( x => x.requisitosGarantiasCantidadTipoVinculaciones = [] );
    reqGarantCantTipVin.forEach( x => {
      const model = this.lisRequisitoCantidadTodos.find( y => x.idRequisitoGarantiaCantidad === y.idRequisitoGarantiaCantidad );
      if ( model ) {
        model.requisitosGarantiasCantidadTipoVinculaciones.push( Object.assign( {}, x ) );
      }
    } );
    this.lisRequisitoCantidadTodos.forEach( x => x.tiposVinculaciones = x.requisitosGarantiasCantidadTipoVinculaciones
      .filter( y => y.indicadorHabilitado )
      .map( y => y.tipoVinculacion ).join( ', ' ) );
  }

  cargarListado() {
    this.lisRequisitoCantidad = this.lisRequisitoCantidadTodos.filter( x => x.indicadorHabilitado );
  }

  cargarFormulario( data? ) {
    this.formulario = this.fb.group( {
      idRequisitoGarantiaCantidad: [ data ? data.idRequisitoGarantiaCantidad : null ],
      idRequisitoGarantia: [ this.requisito.idRequisitoGarantia, [ Validators.required ] ],
      cantidad: [ data ? data.cantidad : null, [ Validators.required, Validators.min( 0 ), Validators.max( 999 ) ] ],
      idTipoVinculacion: [ [], [ Validators.required ] ],
      indicadorHabilitado: [ true ],
    } );
  }

  cargarFormularioDetalle( data ) {
    this.formularioDetalle = this.fb.group( {
      idRequisitoGarantiaCantidad: [ data ? data.idRequisitoGarantiaCantidad : null ],
      idRequisitoGarantia: [ this.requisito.idRequisitoGarantia, [ Validators.required ] ],
      cantidad: [ data ? data.cantidad : null, [ Validators.required, Validators.min( 0 ), Validators.max( 999 ) ] ],
      indicadorHabilitado: [ true ],
    } );
  }

  cargarVinculaciones() {
    this.lisTipoVinculacion = [];
    this.lisTipoVinculacionTodos.forEach( e => {
      if ( !this.lisRequisitoCantidad
        .find( x => !!x.requisitosGarantiasCantidadTipoVinculaciones
          .find( y => y.indicadorHabilitado && y.idTipoVinculacion === e.idLista ) ) ) {
        this.lisTipoVinculacion.push( { label: e.nombre, value: e.idLista } );
      }
    } );
  }

  editar( row ) {
    this.submittedD = false;
    this.cargarFormularioDetalle( row );
    this.editarRequisito = true;
  }

  modificarCantidad() {
    this.submittedD = true;
    if ( !this.formularioDetalle.valid ) {
      return;
    }
    this.cargando = true;
    const registro = this.formularioDetalle.value;
    const model = this.lisRequisitoCantidadTodos.find( x => x.idRequisitoGarantiaCantidad === registro.idRequisitoGarantiaCantidad );
    model.cantidad = registro.cantidad;
    this.reqCantidadService.actualizar( model ).subscribe( r => {
      this.cerrar();
    } );
  }

  cerrar() {
    this.submittedD = false;
    this.editarRequisito = false;
    this.cargando = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }
    this.cargando = true;
    const registro = this.formulario.value;

    const existe = this.lisRequisitoCantidadTodos.find( x => !x.indicadorHabilitado && x.cantidad === registro.cantidad );
    if ( existe ) {
      existe.indicadorHabilitado = true;
      existe.requisitosGarantiasCantidadTipoVinculaciones.forEach( x => x.indicadorHabilitado = false );
      registro.idTipoVinculacion.forEach( x => {
        // Aquí ya existe la vinculación, nada que hacer
        const encontrado = existe.requisitosGarantiasCantidadTipoVinculaciones.find( y => y.idTipoVinculacion === x );
        if ( encontrado ) {
          encontrado.indicadorHabilitado = true;
          return;
        }
        // Si existió para otro, se le asigna a el mismo IdRequisitoGarantiaCantidad
        const model = this.lisRequisitoCantidadTipVin.find( y => y.idTipoVinculacion === x );
        if ( model ) {
          model.idRequisitoGarantiaCantidad = existe.idRequisitoGarantiaCantidad;
          model.indicadorHabilitado = true;
          existe.requisitosGarantiasCantidadTipoVinculaciones.push( Object.assign( {}, model ) );
          return;
        }
        // En este caso, es que no existe dicho registro
        const vinculacion = this.lisTipoVinculacionTodos.find( y => y.idLista === x );
        existe.requisitosGarantiasCantidadTipoVinculaciones.push( {
          idTipoVinculacion: x,
          idRequisitoGarantiaCantidad: existe.idRequisitoGarantiaCantidad,
          tipoVinculacion: !!vinculacion ? vinculacion.nombre : null,
          indicadorHabilitado: true
        } as any );
      } );

      this.reqCantidadService.actualizar( existe ).subscribe( async r => {
        if ( existe.requisitosGarantiasCantidadTipoVinculaciones.length === 0
          || !existe.requisitosGarantiasCantidadTipoVinculaciones.find( z => z.indicadorHabilitado ) ) {
          this.reiniciar();
        } else {
          this.reqCantTipoVinculacionService.bulk( existe.requisitosGarantiasCantidadTipoVinculaciones ).subscribe( () => {
            this.reiniciar();
          } );
        }
      } );
    } else {
      const reqGarCant = {
        idRequisitoGarantia: this.requisito.idRequisitoGarantia,
        indicadorHabilitado: true,
        cantidad: registro.cantidad,
        requisitosGarantiasCantidadTipoVinculaciones: [],
        tiposVinculaciones: null
      };
      this.reqCantidadService.crear( reqGarCant as any )
        .subscribe( r => {
          const listaVinculaciones = [];
          registro.idTipoVinculacion.forEach( x => {
            // Si existió para otro, se le asigna a el mismo IdRequisitoGarantiaCantidad
            const model = this.lisRequisitoCantidadTipVin.find( y => y.idTipoVinculacion === x );
            if ( model ) {
              model.idRequisitoGarantiaCantidad = r.idRequisitoGarantiaCantidad;
              model.indicadorHabilitado = true;
              listaVinculaciones.push( Object.assign( {}, model ) );
              return;
            }
            // En este caso, es que no existe dicho registro
            const vinculacion = this.lisTipoVinculacionTodos.find( y => y.idLista === x );
            listaVinculaciones.push( {
              idTipoVinculacion: x,
              idRequisitoGarantiaCantidad: r.idRequisitoGarantiaCantidad,
              tipoVinculacion: !!vinculacion ? vinculacion.nombre : null
            } );
          } );
          this.reqCantTipoVinculacionService.bulk( listaVinculaciones ).subscribe( () => {
            // reqGarCant.requisitosGarantiasCantidadTipoVinculaciones = listaVinculaciones;
            // this.lisRequisitoCantidadTodos.push(reqGarCant as any);
            this.reiniciar().then();
          } );
        } );
    }
  }

  get f() {
    return this.formulario.controls;
  }

  get fd() {
    return this.formularioDetalle.controls;
  }

  inhablitar( registro: RequisitoGarantiaCantidad ) {
    this.conService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: `tipo-vinculacion`,
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.reqCantidadService.actualizar( registro ).subscribe( r => {
          this.navService.setMesage( 2 );
          this.cargarListado();
          this.cargarVinculaciones();
          this.cargando = false;
        } );
      }
    } );
  }

  private async reiniciar() {
    await this.cargarInicial();
    this.cargarListado();
    this.cargarVinculaciones();
    this.reiniciarForm();
    this.navService.setMesage( 1 );
    this.cargando = false;
  }

  reiniciarForm() {
    this.submitted = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
  }

  salir() {
    this.dismiss.emit( true );
  }

}
